import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';

interface MenuButtonProps {
  text: string;
  onClick?: () => void;
}

export const MenuButton = ({ text, onClick }: MenuButtonProps) => {
  return (
    <MenuButtonContainer onClick={onClick}>
      <ButtonName>{text}</ButtonName>
      <Icon name={'AngleRightDarkGray'} width={14} height={14} />
    </MenuButtonContainer>
  );
};

const MenuButtonContainer = styled.button`
  display: flex;
  height: 48px;
  justify-content: space-between;
  align-items: center;
  gap: var(--radius-medium, 8px);
  align-self: stretch;
`;

const ButtonName = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 13.6px */
`;
